(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-finder"] && !Shopify.designMode) return;
  try {
    
  function initializeRobinFitFinders(root = document) {
    root.querySelectorAll('.rf-finder').forEach((finder) => {
      if (finder.dataset.initialized) return;
      finder.dataset.initialized = 'true';
      const filters = finder.querySelector('.rf-filters');
      filters.hidden = false;
      filters.addEventListener('click', (event) => {
        const button = event.target.closest('[data-rf-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        finder.querySelectorAll('[data-rf-kind]').forEach((card) => {
          card.hidden = button.dataset.rfFilter !== 'all' && card.dataset.rfKind !== button.dataset.rfFilter;
        });
        finder.querySelector('[role="status"]').textContent = button.textContent;
      });
    });
  }
  initializeRobinFitFinders();
  document.addEventListener('shopify:section:load', (event) => initializeRobinFitFinders(event.target));

  } catch(e) { console.error(e); }
})();
})();
